
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assistencia",
      function () {
        return require("private-next-pages/assistencia/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assistencia"])
      });
    }
  